/**
 * Everything before a login — the sign-in page and the password-reset path.
 *
 * THE FIRST SCREENS TRANSLATED, and not by accident: they are the only ones a person meets before
 * they have an account whose preference could be consulted. Everything above rung (b) in the
 * precedence chain is unreachable here, which is why the visible "English / Español" toggle lives on
 * the sign-in page.
 *
 * The reset path is here for the same reason and one more: it is the screen somebody lands on when
 * they are ALREADY stuck. Leaving it in English means a Spanish speaker who has forgotten a password
 * has no way back in that does not go through another person.
 */
export default {
  // ── sign in ───────────────────────────────────────────────────────────────────────────────────
  welcomeBack: 'Welcome Back',
  signInToAccess: (name) => `Sign in to access ${name}`,
  emailAddress: 'Email Address',
  emailPlaceholder: 'Enter your work email',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  forgotPassword: 'Forgot your password?',
  signIn: 'Sign In',
  signingIn: 'Signing In…',
  signInFailed: 'Sign In Failed',
  checkEmailAndPassword: 'Please check your email and password and try again.',
  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email address',
  passwordRequired: 'Password is required',
  needHelp: 'Need help?',
  contactAdministrator: 'Contact your administrator',

  // ── forgotten password: ask for the link ──────────────────────────────────────────────────────
  resetTitle: 'Reset Password',
  resetSubtitle: 'Enter your email address and we’ll send you a reset link',
  resetEmailPlaceholder: 'Enter your email address',
  sendResetLink: 'Send Reset Link',
  sending: 'Sending...',
  resetLinkSent: 'Reset Link Sent',
  resetLinkSentBody: 'Please check your email for the password reset link.',

  // ── forgotten password: set the new one ───────────────────────────────────────────────────────
  setNewPasswordTitle: 'Set New Password',
  setNewPasswordSubtitle: 'Enter your new password below',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'Enter your new password',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordPlaceholder: 'Confirm your new password',
  resetPassword: 'Reset Password',
  resetting: 'Resetting...',
  resetSucceededTitle: 'Password Reset Successful',
  resetSucceededBody: 'Your password has been reset. Redirecting to login...',
  resetSucceededSignInNow: 'Password reset successful. Please log in with your new password.',
  newPasswordRequired: 'New password is required',
  passwordTooShort: 'Password must be at least 8 characters long',
  confirmYourPassword: 'Please confirm your password',
  passwordsDoNotMatch: 'Passwords do not match',
  backToSignIn: 'Back to sign in',
  error: 'Error',
}
